module.exports = __webpack_public_path__ + "static/img/samajuri (31).5d3b397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (31).jpg
// module id = +41r
// module chunks = 0